/* ══════════════════════════════════════════════════════════════
   Marathi (mr) — मराठी Translation File
   ══════════════════════════════════════════════════════════════ */

export const mr = {
    app: {
        name: 'इंडिया मार्केट मॉनिटर',
        tagline: 'AI-चालित भारतीय बाजार बुद्धिमत्ता',
    },
    nav: {
        dashboard: 'डॅशबोर्ड',
        strategy: 'रणनीती',
        intelligence: 'इंटेलिजन्स',
        markets: 'बाजार',
        indiaMap: 'भारताचा नकाशा',
        ipoEarnings: 'IPO आणि कमाई',
        backtest: 'बॅकटेस्ट',
        settings: 'सेटिंग्ज',
        search: 'कंपनी, बातम्या शोधा…',
    },
    dashboard: {
        title: 'डॅशबोर्ड',
        marketStatus: 'बाजार स्थिती',
        open: 'सुरू',
        closed: 'बंद',
        preOpen: 'प्री-ओपन',
        holiday: 'सुट्टी',
        strategyCard: 'आजची रणनीती',
        marketRadar: 'मार्केट रडार',
        fiiDii: 'FII / DII प्रवाह',
        quickStats: 'जलद आकडेवारी',
        newsTicker: 'प्राधान्य बातम्या',
        liveTV: 'लाइव्ह टीव्ही',
        viewDetails: 'तपशील पहा →',
    },
    strategy: {
        title: 'रणनीती',
        regime: 'बाजार रिजीम',
        regimeTypes: {
            trendingBull: 'तेजीचा कल',
            trendingBear: 'मंदीचा कल',
            sideways: 'साइडवेज',
            highVol: 'उच्च अस्थिरता',
        },
        confidence: 'विश्वास',
        entry: 'प्रवेश',
        target: 'लक्ष्य',
        stopLoss: 'स्टॉप लॉस',
        buy: 'खरेदी करा',
        sell: 'विक्री करा',
        hold: 'धरा',
        featureImportance: 'फीचर महत्त्व',
        keyLevels: 'मुख्य पातळ्या',
        support: 'सपोर्ट',
        resistance: 'रेसिस्टन्स',
        currentPrice: 'सध्याची किंमत',
    },
    intelligence: {
        title: 'इंटेलिजन्स',
        morningBrief: 'सकाळचा संक्षेप',
        priorityFeed: 'प्राधान्य फीड',
        sectorIntel: 'क्षेत्र बुद्धिमत्ता',
        earningsTracker: 'कमाई',
        eventTimeline: 'कार्यक्रम',
        newsSearch: 'शोधा',
        bullish: 'तेजी',
        bearish: 'मंदी',
        neutral: 'तटस्थ',
    },
    markets: {
        title: 'बाजार',
        indices: 'निर्देशांक',
        options: 'ऑप्शन्स',
        sectors: 'क्षेत्रे',
        commodities: 'वस्तू',
        currency: 'चलन',
        breadth: 'ब्रेड्थ',
        advancing: 'वाढणारे',
        declining: 'घसरणारे',
    },
    ipo: {
        title: 'IPO आणि कमाई',
        dashboard: 'IPO डॅशबोर्ड',
        earningsTracker: 'कमाई ट्रॅकर',
        upcoming: 'येणारे IPO',
        subscribe: 'सबस्क्राइब करा',
        avoid: 'टाळा',
        revenue: 'महसूल',
        verdict: 'निर्णय',
        beat: 'बीट',
        miss: 'मिस',
    },
    backtest: {
        title: 'बॅकटेस्ट',
        equityCurve: 'इक्विटी वक्र',
        riskMetrics: 'जोखीम मेट्रिक्स',
        monthlyReturns: 'मासिक परतावा',
        tradeLog: 'व्यापार नोंद',
        totalReturn: 'एकूण परतावा',
        winRate: 'विजय दर',
    },
    map: {
        title: 'भारताचा नकाशा',
        selectState: 'राज्य निवडा',
        gdp: 'GDP',
        growth: 'वाढ',
        keySectors: 'मुख्य क्षेत्रे',
    },
    settings: {
        title: 'सेटिंग्ज',
        language: 'भाषा',
        selectLanguage: 'भाषा निवडा',
        darkMode: 'डार्क मोड',
        lightMode: 'लाइट मोड',
    },
    sectorRotation: {
        title: 'क्षेत्र रोटेशन',
        leading: 'अग्रेसर',
        weakening: 'कमकुवत',
        lagging: 'मागे',
        improving: 'सुधारणा',
    },
    election: {
        title: 'निवडणूक प्रभाव',
        upcomingElections: 'येणाऱ्या निवडणुका',
        state: 'राज्य',
        historicalImpact: 'ऐतिहासिक निफ्टी प्रभाव',
        avgReturn: 'सरासरी निफ्टी परतावा',
    },
    budget: {
        title: 'अर्थसंकल्प प्रभाव',
        unionBudget: 'केंद्रीय अर्थसंकल्प 2026-27',
        daysLeft: '{{days}} दिवस बाकी',
        increase: 'वाढ',
        decrease: 'कपात',
    },
    common: {
        loading: 'लोड होत आहे…',
        error: 'काहीतरी चूक झाली',
        retry: 'पुन्हा प्रयत्न करा',
        noData: 'डेटा उपलब्ध नाही',
        viewAll: 'सर्व पहा',
        close: 'बंद करा',
        save: 'जतन करा',
        cancel: 'रद्द करा',
        crore: 'कोटी',
        lakh: 'लाख',
        rupee: '₹',
        disclaimer: 'हा आर्थिक सल्ला नाही. केवळ माहितीसाठी.',
    },
};
